export default class Prova {
    constructor() {
        this.arquivo = [],
        this.descricao = '',
        this.instituicao = '',
        this.ano = '', 
        this.idResidencia = ''
        this.downloads = '',
        this.chaveBucket = '',
        this.complemento = ''
    }

    clean() {
        this.arquivo = [],
        this.descricao = '',
        this.instituicao = '',
        this.ano = '', 
        this.idResidencia = '',
        this.downloads = '',
        this.chaveBucket = ''
    }
}